export const firebaseConfig = {
    apiKey: "AIzaSyCaMqsovNfbBHZG-QioFrBQEoHeXwrITHI",
    authDomain: "volunteer-network-main-5680d.firebaseapp.com",
    databaseURL: "https://volunteer-network-main-5680d.firebaseio.com",
    projectId: "volunteer-network-main-5680d",
    storageBucket: "volunteer-network-main-5680d.appspot.com",
    messagingSenderId: "560881564517",
    appId: "1:560881564517:web:ede2c0466be9697a623f8c"
};